<div class="tables-layout">
  <div class="title-bar title-bar--responsive tables-header">
    <div class="title-bar__heading tables-header__title">
      <h1>TABLES</h1>
      <app-help screen="tables"></app-help>
    </div>
    <div class="title-bar__actions tables-header__actions">
      <button mat-flat-button color="primary" class="tables-header__button" (click)="createTable()">
        <mat-icon fontIcon="add" aria-hidden="true"></mat-icon>
        <span>New Table</span>
      </button>
      <app-aid-year [disabled]="false"></app-aid-year>
    </div>
  </div>

  <mat-card appearance="outlined">
    @if (cc.tables | async; as tables) {
      <div>
        @if (tables.length > 0) {
          <div class="tables-grid-wrapper" appKeyboardScrollable>
            <table class="table table-hover tables-grid">
              <thead>
                <tr>
                  <th scope="col">Table</th>
                  <th scope="col">Input</th>
                  <th scope="col">
                    Usage
                    <br />
                    <span class="legend-population">Population</span>
                    <span class="legend-cost">Cost</span>
                    <br />
                    <span class="legend-package">Package</span>
                    <span class="legend-formula">Formula</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (table of tables; track trackByTableId($index, table)) {
                  <tr
                    class="tables-row"
                    (click)="openTable(table)"
                    >
                    <th scope="row">
                      <a
                        class="link"
                        role="button"
                        tabindex="0"
                        (click)="activateTable($event, table)"
                        (keydown.enter)="activateTable($event, table)"
                        (keydown.space)="activateTable($event, table)"
                        >
                        {{ table.name }}
                      </a>
                      <div class="description" [innerHTML]="table.description"></div>
                    </th>
                    <td>
                      @if (table.matrixTable) {
                        <div>{{ matrixTableSummary(table) }}</div>
                      } @else if (table.type === 'Question' || table.type === 'Calculation') {
                        <div>
                          {{ getSelectorName(table.keyId) }}
                        </div>
                      }
                      @if (!table.matrixTable && table.type === 'Formula') {
                        <div>
                          Formula ({{ table.formulaId }}):
                          <strong>{{ table.formula?.name }}</strong>
                          <br />
                          <small>{{ table.formula?.description }}</small>
                        </div>
                      }
                    </td>
                    <td>
                      <app-usage entityType="Table" [entityId]="table.tableId"></app-usage>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="tables-empty">
            <p>There are no tables yet.</p>
            <button mat-button color="secondary" (click)="createTable()">Add new table</button>
          </div>
        }
      </div>
    }
  </mat-card>
</div>
